import { render, staticRenderFns } from "./DetailHistoryActionDialog.vue?vue&type=template&id=edfc0862&scoped=true"
import script from "./DetailHistoryActionDialog.vue?vue&type=script&lang=js"
export * from "./DetailHistoryActionDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailHistoryActionDialog.vue?vue&type=style&index=0&id=edfc0862&lang=scss"
import style1 from "./DetailHistoryActionDialog.vue?vue&type=style&index=1&id=edfc0862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc0862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfc0862')) {
      api.createRecord('edfc0862', component.options)
    } else {
      api.reload('edfc0862', component.options)
    }
    module.hot.accept("./DetailHistoryActionDialog.vue?vue&type=template&id=edfc0862&scoped=true", function () {
      api.rerender('edfc0862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/DetailHistoryActionDialog.vue"
export default component.exports